import React, { useCallback, useState, createContext, useContext } from 'react';
import Toast, { ToastType } from './Toast';
interface ToastContextType {
  showToast: (message: string, type?: ToastType, title?: string, duration?: number) => void;
}
const ToastContext = createContext<ToastContextType>({
  showToast: () => {}
});
export const useToast = () => useContext(ToastContext);
interface ToastProviderProps {
  children: React.ReactNode;
}
export const ToastProvider: React.FC<ToastProviderProps> = ({
  children
}) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState<string | undefined>(undefined);
  const [type, setType] = useState<ToastType>('success');
  const [duration, setDuration] = useState(4000);
  const showToast = useCallback((message: string, type: ToastType = 'success', title?: string, duration: number = 4000) => {
    setMessage(message);
    setType(type);
    setTitle(title);
    setDuration(duration);
    setOpen(true);
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  return <ToastContext.Provider value={{
    showToast
  }} data-id="element-1304">
      {children}
      <Toast open={open} message={message} title={title} type={type} duration={duration} onClose={handleClose} data-id="element-1305" />
    </ToastContext.Provider>;
};
export default ToastProvider;